export type IRoute = {
  path: string;
  labelKey: string;
};

export enum AppUrls {
  BUNKERING_DASHBOARD = '/bunkering-dashboard',
  MFM_COMPARISON = '/mfm-comparison',
  BUNKERING_LOGS = '/bunkering-logs',
  ALARM_LOGS = '/alarm-logs',
  SETTINGS = '/settings',
}

export const appRoutes: IRoute[] = [
  {
    path: AppUrls.BUNKERING_DASHBOARD,
    labelKey: 'bunkeringDashboard',
  },
  {
    path: AppUrls.MFM_COMPARISON,
    labelKey: 'mfmComparison',
  },
  {
    path: AppUrls.BUNKERING_LOGS,
    labelKey: 'bunkeringLogs',
  },
  {
    path: AppUrls.ALARM_LOGS,
    labelKey: 'alarmLogs',
  },
];
